import React, { Component } from 'react';
import Navbar from './mycomponents/navbar';
import ViewCourseAttendanceBody from './mycomponents/viewcourseattendancebody';

class ViewCourseAttendance extends Component {
    state = {  } 
    render() { 
        return (
            <React.Fragment>
            <Navbar/>
            <ViewCourseAttendanceBody />
                </React.Fragment>
        );
    }
}
 
export default ViewCourseAttendance;